import { Injectable } from '@angular/core';
import { StorageKeys } from '@core/enums';
import { CountryRulesV2 } from '@core/interface';

@Injectable({
  providedIn: 'root',
})
export class RulesService {

  getRules(): CountryRulesV2 {
    const countryRules = sessionStorage.getItem(StorageKeys.COUNTRY_RULES);
    if (countryRules) {
      return JSON.parse(countryRules) as CountryRulesV2;
    }
    return {} as CountryRulesV2;
  }

  setRules(rules: CountryRulesV2): void {
    sessionStorage.setItem(StorageKeys.COUNTRY_RULES, JSON.stringify(rules));
  }
}
